import { takeEvery, put, all, select } from 'redux-saga/effects';
import { openModalDialog } from '@nextiva/crm-modals/index';

import Constants from 'constants/actions';
import {
  persistBlockUpdate,
  setSurveyStatusPendingState,
  updateBlock,
  updateEditSurveyStatus,
} from '../../actions/surveyEditorActions';
import modalTypes from '../../constants/AppModalTypes';
import { patchSurveyStatus } from '../../actions/surveyListActions';
import { getEditorEntityId, getEditSurveyStatus } from '../../reducers';
import isSurveyStatusChangeConfirmationRequired from '../../utils/isSurveyStatusChangeConfirmationRequired';
import {
  PATCH_SURVEY_STATUS_REQUEST,
  PATCH_SURVEY_STATUS_SUCCESS,
  PATCH_SURVEY_STATUS_FAILURE,
} from '../../constants/surveyList/SurveyListActions';

function* onSetEditorLoadingState({ payload }) {
  yield put(setSurveyStatusPendingState(payload));
}

function* onChangeEditSurveyStatus({ payload: { status } }) {
  const currentStatus = yield select(getEditSurveyStatus);
  const surveyId = yield select(getEditorEntityId);

  yield put(
    isSurveyStatusChangeConfirmationRequired(currentStatus, status)
      ? openModalDialog({
          type: modalTypes.changeSurveyStatus,
          surveyId,
          status,
        })
      : patchSurveyStatus(null, surveyId, status),
  );
}

function* onPatchSurveyStatusRequest() {
  yield put(setSurveyStatusPendingState(true));
}

function* onPatchSurveyStatusSuccess({ data: { status } }) {
  yield put(setSurveyStatusPendingState(false));
  yield put(updateEditSurveyStatus(status));
}

function* onPatchSurveyStatusFailure() {
  yield put(setSurveyStatusPendingState(false));
}

function* onUpdateBlockRequest({ payload: { blockData, index } }) {
  yield put(updateBlock(index, blockData));
}

function* onPersistBlockUpdateRequest({ payload: { clientUuid, updatedBlock } }) {
  yield put(persistBlockUpdate(clientUuid, updatedBlock));
}

export default function*() {
  yield all([
    takeEvery(Constants.SET_EDITOR_LOADING_STATE, onSetEditorLoadingState),
    takeEvery(Constants.CHANGE_EDIT_SURVEY_STATUS, onChangeEditSurveyStatus),
    takeEvery(PATCH_SURVEY_STATUS_REQUEST, onPatchSurveyStatusRequest),
    takeEvery(PATCH_SURVEY_STATUS_SUCCESS, onPatchSurveyStatusSuccess),
    takeEvery(PATCH_SURVEY_STATUS_FAILURE, onPatchSurveyStatusFailure),
    takeEvery(Constants.UPDATE_BLOCK_REQUEST, onUpdateBlockRequest),
    takeEvery(Constants.PERSIST_BLOCK_UPDATE_REQUEST, onPersistBlockUpdateRequest),
  ]);
}
